import { useIsFetching } from 'react-query';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { GlobalFiltersInPage } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import { ActivityCodesFilter } from 'components/common/GlobalFiltersInPage/components/ActivityCodesFilter/ActivityCodesFilter';
import { MilestoneFragnetFilter } from 'components/common/GlobalFiltersInPage/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { TagsFilter } from 'components/common/GlobalFiltersInPage/components/TagsFilter/TagsFilter';
import { WbsFilter } from 'components/common/GlobalFiltersInPage/components/WbsFilter/wbsFilter';
import { GlobalFilterFieldKey } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';

import { riskConfig } from 'components/Dashboards/ExcellenceApps/riskConfig';
import { useScrollTo } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramProgressOverview/useScrollTo';
import { ProgramCriticalAnalysisQueryKeys } from 'components/Dashboards/Project/Components/VersionCompare/VersionCompare.consts';
import { TreeProgramTopHeader } from 'components/common';
import { CriticalActivitiesAndDelayDrivers } from 'components/widgets/CriticalActivitiesAndDelayDrivers/RenderCriticalAnalysisDelayDrivers';
import { RiskDensity } from 'components/widgets/RiskDensity/RiskDensity';
import { SharedResourcesAvailabilityWrapper } from 'components/widgets/SharedResourcesAvailability/sharedResourcesAvailabilityWrapper';
import { RenderTopDurationOverrunRisk } from 'components/widgets/TopDurationOverrunRisk/topDurationOverrunRisk';

const CriticalityAndRiskPage = () => {
    useFullStoryPageView({ pageName: riskConfig.criticalityAnalysis.title });
    const isFetching = useIsFetching({
        predicate: (query) => {
            const key = Array.isArray(query.queryKey) ? query.queryKey[0] : query.queryKey;
            return ProgramCriticalAnalysisQueryKeys.includes(key);
        },
    });
    useScrollTo(isFetching);

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader>
                            <ShareInsightButton
                                title={riskConfig.criticalityAnalysis.title}
                                link={window.location.href}
                            />
                            <GlobalFilterButton />
                        </TreeProgramTopHeader>
                    </VersionSection>
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={riskConfig.criticalityAnalysis.title}></ProgramTopHeader>
                    <GlobalFiltersInPage
                        defaultValues={{
                            [GlobalFilterFieldKey.milestoneFragnet]: null,
                            [GlobalFilterFieldKey.tags]: [],
                            [GlobalFilterFieldKey.activityCodes]: [],
                            [GlobalFilterFieldKey.wbs]: null,
                        }}
                    >
                        <MilestoneFragnetFilter name={GlobalFilterFieldKey.milestoneFragnet} />
                        <TagsFilter name={GlobalFilterFieldKey.tags} />
                        <ActivityCodesFilter name={GlobalFilterFieldKey.activityCodes} />
                        <WbsFilter name={GlobalFilterFieldKey.wbs} />
                    </GlobalFiltersInPage>
                </BottomHeaderSection>
            </HeaderWrapper>

            <MainContent>
                <PageWidgetWrapper>
                    <RiskDensity />
                    <CriticalActivitiesAndDelayDrivers />
                    <RenderTopDurationOverrunRisk />
                    <SharedResourcesAvailabilityWrapper />
                </PageWidgetWrapper>
            </MainContent>
            <MainCardRoutingModal queryKeys={ProgramCriticalAnalysisQueryKeys} />
        </PageContainer>
    );
};

export default CriticalityAndRiskPage;
